import React from 'react';
import { Card, Dropdown } from '@bynder/design-system';
import { IconAdd, IconDelete, IconEdit, IconMore, IconStateIndicatorM } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';
import { PartialComponent } from 'packages/services/ComponentService';
import { useFriendlyTime } from '~/hooks/useFriendlyTime';

interface Props {
    component: PartialComponent;
    collectionName: string;
    onApply: (isUniqueContentProperties: boolean) => void;
    onEdit: () => void;
    onDelete: () => void;
}

const ComponentMenu = ({ component, collectionName, onApply, onEdit, onDelete }: Props) => {
    const { translate } = useTranslate();
    const { getFriendlyTime } = useFriendlyTime();

    return (
        <Dropdown
            trigger={({ isOpen, ...triggerProps }) => (
                <Card.ContextActionButton
                    aria-label={translate('components.overview.card.menu')}
                    isPressed={isOpen}
                    {...triggerProps}
                >
                    <IconMore />
                </Card.ContextActionButton>
            )}
        >
            <Dropdown.SectionTitle>
                <b>{component.name}</b>
            </Dropdown.SectionTitle>
            {component.description && <Dropdown.SectionTitle>{component.description}</Dropdown.SectionTitle>}
            <Dropdown.SectionTitle>
                <IconStateIndicatorM />
                {collectionName}
            </Dropdown.SectionTitle>
            <Dropdown.SectionTitle>
                <IconStateIndicatorM />
                {getFriendlyTime(component.created)}
            </Dropdown.SectionTitle>
            <Dropdown.Divider />
            <Dropdown.Item onClick={() => onApply(true)} icon={<IconAdd />}>
                {translate('components.overview.card.menu.uniqueContentProperties')}
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={() => onEdit()} icon={<IconEdit />}>
                {translate('components.overview.card.menu.editDetails')}
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={() => onDelete()} icon={<IconDelete />}>
                {translate('components.overview.card.menu.delete')}
            </Dropdown.Item>
        </Dropdown>
    );
};

export default ComponentMenu;
